// Shared close-writer for AppDialog (see components/AppDialog.js). Any
// descendant of an AppDialog (backdrop, header close button, footer cancel
// button) calls this with the dialog's `stateKey` (+ optional `extraClose`
// patch) to null it out — the exact `root.update({[stateKey]: null, ...})`
// shape already proven in packages/shared/components/Modal.js's
// `_maybeDismiss`, generalized so AppDialog doesn't need its own module-level
// singleton (Rule 33 — no module-level closures).
export function appDialogClose(stateKey, extraClose) {
  const el = this
  if (!stateKey) return
  const root = el.state && el.state.root
  if (!root || !root.update) return
  root.update(extraClose && typeof extraClose === 'object' ? { [stateKey]: null, ...extraClose } : { [stateKey]: null })
}
